import React from "react";
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react"; 

interface BreadCrumbProps {
  title: string;
  pageTitle: string;
}

const BreadCrumb = ({ title, pageTitle }: BreadCrumbProps) => {
  document.title = `${title} / ${pageTitle}`;
  return (
    <React.Fragment>
      <div className="flex card p-4 mt-4 justify-start  gap-2 py-4 flex-row md:items-center print:hidden">
        <ul className="flex items-center gap-2 text-sm font-normal shrink-0 rtl:flex-row-reverse">
          <li className="text-slate-700 dark:text-zink-100">{title}</li>
          <li className="flex items-center gap-1 text-slate-400 dark:text-zink-200">
            <Link to="#" className="flex items-center gap-1">
              {pageTitle}
              <ChevronLeft size={18} className="text-slate-400 dark:text-zink-200" />
            </Link>
          </li>
        </ul>
      </div>
    </React.Fragment>
  );
};

export default BreadCrumb;
